<div class="pl-pane">
  <se-fe-empty-state [seFeDataTitle]="'PAGE.empty_state' | translate">
    <se-fe-icon seFeEmptyStateIcon seFeDataName="clipboard_thin" seFeDataSize="950"></se-fe-icon>
    {{ 'PAGE.not_found' | translate }}
  </se-fe-empty-state>
</div>
